import { app } from '../../../app';

app.service('PasswordManagers', PasswordManagers);

/** @ngInject */
function PasswordManagers($http) {

    return {
        list,
        remove,
        importItems,
        getImportFileTypes,
        getPassword,
        getOtp,
        getCorporateOtp,
        getCorporatePassword
    };

    function list() {
        return $http
            .get(`app/rest/loginitems`)
            .then(response => response.data);
    }

    function remove(id) {
        return $http
            .delete(`app/rest/loginitems/${id}`)
            .then(response => response.data);
    }
    
    
    function importItems( fileType, file,successAction, errorAction) {
        var fd = new FormData();
        fd.append('file', file);

        var uploadUrl = "app/rest/loginitems/import?fileType=:fileType"
            .replace(":fileType", fileType);

        $http.post(uploadUrl, fd, {
            transformRequest : angular.identity,
            headers : {
                'Content-Type' : undefined
            }
        })
        .then((response) => successAction(response.data))
        .catch((response) => errorAction(response.data, response.status));
    }
    function getImportFileTypes() {
        return $http
            .get(`app/rest/loginitems/import`)
            .then(response => response.data);
    }
    function getPassword(id) {
        return $http
            .get(`app/rest/loginitems/${id}/PASSWORD`)
            .then(response => response.data);
    }
    function getOtp(id) {
        return $http
            .get(`app/rest/authenticators/${id}/OTP`)
            .then(response => response.data);
    }
    function getCorporatePassword(id) {
        return $http
            .get(`app/rest/corporateServices/${id}/ALL`)
            .then(response => response.data);
    }
    function getCorporateOtp(id) {
        return $http
            .get(`app/rest/corporateServices/${id}/OTP`)
            .then(response => response.data);
    }

}



// WEBPACK FOOTER //
// ./src/portal/states/user/public-user-accounts/password-manager.service.js